
  import notifications from '~/mixins/pages/mission-control/notifications'
  export default {
    name: 'Theme3DesktopNotification',
    mixins: [notifications]
  }
